module.exports = __webpack_public_path__ + "static/media/5_fanout_to_multifiber_B_aqua_square.66d88d1c.png";